import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background_white};
  box-shadow: 0px 1px 9px #00000029;
  padding: 0.5rem 0;
  border-radius: 1rem;

  .header {
    display: flex;
    padding: 0.5rem 0;
    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.25rem;
      font-weight: 500;
      margin-left: 0.6rem;
    }
  }

  .table {
    box-shadow: 0px 0px 0px 0px ${({ theme }) => theme.colors.background_white};
    max-height: 15rem;
    overflow-y: scroll !important;
    .MuiTable-root {
      min-width: 0px !important;
    }

    tr:nth-child(odd) {
      background: ${({ theme }) => theme.colors.background_white};
    }

    tr th,
    td {
      padding: 6px 7px;
    }

    td div {
      display: flex;
      flex-direction: column;
      width: 10rem;

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .expires {
        display: flex;
        flex-direction: row;
      }
    }

    .icon-demands svg {
      width: 2rem;
      height: 2rem;
      color: ${({ theme }) => theme.colors.secondary};
    }

    span {
      color: ${({ theme }) => theme.colors.tertiary_500};
    }

    .expired {
      color: ${({ theme }) => theme.colors.error_500};
    }

    .action {
      svg {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }

    p {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
      opacity: 1;
    }
  }

  @media (max-width: 1250px) {
    .table {
      td div {
        width: 8rem !important;
      }

      .services {
        display: none;
      }
    }
  }
`;
